import React, { Fragment } from 'react';
import { SecondaryLine, TotalLine } from './Lines';
import MathBoxGroup from './MathBoxGroup';

const TotalVehicleAndOptionsGroup = ({ pricing, isSummary, isFamilyFirst }) => {
  const {
    totalMsrpWithOptions,
    destination,
    gasGuzzlerTax,
    acTax,
    dealerFee,
    isSeeDealer,
    miscFees,
    luxuryTax
  } = pricing;

  if (isSeeDealer) {
    return null;
  }

  const LuxuryTaxLine = () => {
    if (!isFamilyFirst && luxuryTax && luxuryTax.val) {
      return <SecondaryLine label={luxuryTax.label} value={luxuryTax.val} />;
    }

    return null;
  };

  return (
    <MathBoxGroup ruled>
      <TotalLine
        labelKey="total.vehicle.price.with.options"
        value={totalMsrpWithOptions}
      />
      <SecondaryLine labelKey="destination.charge" value={destination} />
      <SecondaryLine
        labelKey="component.pricing.gas.guzzler.tax"
        value={gasGuzzlerTax}
      />
      <SecondaryLine labelKey="component.pricing.ac.tax" value={acTax} />
      <SecondaryLine
        labelKey="component.pricing.dealer.fees"
        value={dealerFee}
      />
      {miscFees && (
        <Fragment>
          {miscFees.map(fee => (
            <SecondaryLine
              key={fee.label}
              label={fee.label}
              value={fee.cw.value}
              disclaimer={fee.disclaimer}
              isDisabled={isSummary}
            />
          ))}
        </Fragment>
      )}
      <LuxuryTaxLine />
    </MathBoxGroup>
  );
};

export default TotalVehicleAndOptionsGroup;
